// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"197":"a86b6db96076c0a0c6b4","929":"6e521c3fbfb17f43790e"}[chunkId] + ".js";
};